export default __webpack_public_path__ + "static/media/IMG2.dbaa3f6a.jpg";